module.exports = __webpack_public_path__ + "img/remove_field.d690d89d.svg";